export default __webpack_public_path__ + "static/media/copy.ad81ded5.svg";